import { XData } from '@core/utils';
import axios from '@modules/raccoon/src/api';

const endpoint = 'raporty';

export const getRaportyStartowe = () =>
  axios.get(`${endpoint}/Raportydblista`).then(XData.deepLowercaseResData);

export const getRaportStartowy = (id) =>
  axios.get(`${endpoint}/raportyDbGet?id=${id}`);
